import {css} from 'styled-components';

import fonts from './base';

export const fontSizeD0 = css`
  font-size: ${fonts.size.d0};
  line-height: ${fonts.lineHeight.default};
`;

export const fontSizeD1 = css`
  font-size: ${fonts.size.d1};
  line-height: ${fonts.lineHeight.default};
`;

export const fontSizeD2 = css`
  font-size: ${fonts.size.d2};
  line-height: ${fonts.lineHeight.default};
`;

export const fontSizeH1 = css`
  font-size: ${fonts.size.h1};
  line-height: ${fonts.lineHeight.default};
`;

export const fontSizeH2 = css`
  font-size: ${fonts.size.h2};
  line-height: ${fonts.lineHeight.default};
`;

export const fontSizeH3 = css`
  font-size: ${fonts.size.h3};
  line-height: ${fonts.lineHeight.default};
`;

export const fontSizeH4 = css`
  font-size: ${fonts.size.h4};
  line-height: ${fonts.lineHeight.default};
`;

export const fontSizeB1 = css`
  font-size: ${fonts.size.b1};
  line-height: ${fonts.lineHeight.default};
`;

export const fontSizeB2 = css`
  font-size: ${fonts.size.b2};
  line-height: ${fonts.lineHeight.default};
`;

export const fontSizeB3 = css`
  font-size: ${fonts.size.b3};
  line-height: ${fonts.lineHeight.default};
`;
